import { Routes as Switch, Route, useLocation, Navigate } from 'react-router-dom'
import { ReactElement, Suspense, lazy, useEffect, useState } from 'react'
import { AuthProvider, useAuthContext } from '../contexts/auth'
import { hasAuthParams, useAuth } from 'react-oidc-context'
import { useInicializarUsuario } from '../hooks/useInicializarUsuario'
import { LoadingPage } from '../components/LoadingPage'
import { FuncionalidadesGeral } from '../helpers/funcionalidades'
import LayoutDefault from '../components/Layout'

const Dashboard = lazy(() => import('../pages/Dashboard'))
const ProcessosMprj = lazy(() =>
  import('../pages/ProcessosMprj').then((module) => ({ default: module.ProcessosMprj })),
)
const ConsultarAtendimentos = lazy(() =>
  import('../pages/ConsultarAtendimentos').then((module) => ({ default: module.ConsultarAtendimentos })),
)
const VisualizarAtendimento = lazy(() =>
  import('../pages/VisualizarAtendimento').then((module) => ({ default: module.VisualizarAtendimento })),
)
const RegistroManual = lazy(() =>
  import('../pages/RegistroManual').then((module) => ({ default: module.RegistroManual })),
)
const CadastrarServicoArea = lazy(() =>
  import('../pages/CadastrarServicoArea').then((module) => ({ default: module.CadastrarServicoArea })),
)
const ConsultarServicoArea = lazy(() =>
  import('../pages/ConsultarServicoArea').then((module) => ({ default: module.ConsultarServicoArea })),
)
const CadastrarPergunta = lazy(() =>
  import('../pages/CadastrarPergunta').then((module) => ({ default: module.CadastrarPergunta })),
)
const CadastrarFormulario = lazy(() =>
  import('../pages/CadastrarFormulario').then((module) => ({ default: module.CadastrarFormulario })),
)
const ConsultarAssunto = lazy(() =>
  import('../pages/ConsultarAssunto').then((module) => ({ default: module.ConsultarAssunto })),
)
const CadastrarAssunto = lazy(() =>
  import('../pages/CadastrarAssunto').then((module) => ({ default: module.CadastrarAssunto })),
)
const VisualizarAssunto = lazy(() =>
  import('../pages/VisualizarAssunto').then((module) => ({ default: module.VisualizarAssunto })),
)
const VisualizarServicoArea = lazy(() =>
  import('../pages/VisualizarServicoArea').then((module) => ({ default: module.VisualizarServicoArea })),
)
const VisualizarPergunta = lazy(() =>
  import('../pages/VisualizarPergunta').then((module) => ({ default: module.VisualizarPergunta })),
)
const ConsultarPergunta = lazy(() =>
  import('../pages/ConsultarPergunta').then((module) => ({ default: module.ConsultarPergunta })),
)
const ConsultarDominio = lazy(() =>
  import('../pages/ConsultarDominio').then((module) => ({ default: module.ConsultarDominio })),
)
const VisualizarDominio = lazy(() =>
  import('../pages/VisualizarDominio').then((module) => ({ default: module.VisualizarDominio })),
)
const ConsultarMetodo = lazy(() =>
  import('../pages/ConsultarMetodo').then((module) => ({ default: module.ConsultarMetodo })),
)
const VisualizarMetodo = lazy(() =>
  import('../pages/VisualizarMetodo').then((module) => ({ default: module.VisualizarMetodo })),
)
const CadastrarMetodo = lazy(() =>
  import('../pages/CadastrarMetodo').then((module) => ({ default: module.CadastrarMetodo })),
)
const CadastrarDominio = lazy(() =>
  import('../pages/CadastrarDominio').then((module) => ({ default: module.CadastrarDominio })),
)
const ConsultarFormulario = lazy(() =>
  import('../pages/ConsultarFormulario').then((module) => ({ default: module.ConsultarFormulario })),
)
const ConsultarSecao = lazy(() =>
  import('../pages/ConsultarSecao').then((module) => ({ default: module.ConsultarSecao })),
)
const VisualizarSecao = lazy(() =>
  import('../pages/VisualizarSecao').then((module) => ({ default: module.VisualizarSecao })),
)
const VisualizarFormulario = lazy(() =>
  import('../pages/VisualizarFormulario').then((module) => ({ default: module.VisualizarFormulario })),
)
const CadastrarSecao = lazy(() =>
  import('../pages/CadastrarSecao').then((module) => ({ default: module.CadastrarSecao })),
)
const CadastrarAtendimento = lazy(() =>
  import('../pages/CadastrarAtendimento').then((module) => ({ default: module.CadastrarAtendimento })),
)
const OrientacaoPage = lazy(() =>
  import('../pages/CadastrarAtendimento/orientacao').then((module) => ({ default: module.OrientacaoPage })),
)
const AditamentoPage = lazy(() =>
  import('../pages/CadastrarAtendimento/aditamento').then((module) => ({ default: module.AditamentoPage })),
)
const ConsultaPage = lazy(() =>
  import('../pages/CadastrarAtendimento/consulta').then((module) => ({ default: module.ConsultaPage })),
)
const ComunicacaoPage = lazy(() =>
  import('../pages/CadastrarAtendimento/comunicacao').then((module) => ({ default: module.ComunicacaoPage })),
)
const CaixaEntrada = lazy(() =>
  import('../pages/CaixaEntrada').then((module) => ({ default: module.CaixaEntrada })),
)
const ComunicacaoAnalisePage = lazy(() =>
  import('../pages/CaixaEntrada/comunicacao').then((module) => ({ default: module.ComunicacaoAnalisePage })),
)
const VinculosComunicacaoPage = lazy(() =>
  import('../pages/CaixaEntrada/vinculos').then((module) => ({ default: module.VinculosComunicacaoPage })),
)
const EncaminharProvidenciaPage = lazy(() =>
  import('../pages/CaixaEntrada/tratativas/EncaminharProvidencia').then((m) => ({ default: m.EncaminharProvidenciaPage || m.default }))
)
const ResponderPage = lazy(() =>
  import('../pages/CaixaEntrada/tratativas/Responder').then((m) => ({ default: m.ResponderPage || m.default }))
)
const VisualizarAnexosTrativasPage = lazy(() =>
  import('../pages/CaixaEntrada/tratativas/VisualizarAnexosTratativas').then((m) => ({ default: m.VisualizarAnexosTrativasPage || m.default }))
)
const AdicionarComentarioPage = lazy(() =>
  import('../pages/CaixaEntrada/tratativas/AdicionarComentario').then((m) => ({ default: m.AdicionarComentarioPage || m.default }))
)
const Complementacao = lazy(() =>
  import('../pages/Complementacao').then((module) => ({ default: module.Complementacao })),
)
const ConsultaComunicacaoPublicaPage = lazy(() =>
  import('../pages/Publico/ConsultaComunicacao').then((m) => ({ default: m.ConsultaComunicacaoPublicaPage })),
)
const RecuperarSenhaPublicaPage = lazy(() =>
  import('../pages/Publico/RecuperarSenha').then((m) => ({ default: m.RecuperarSenhaPublicaPage })),
)
const ResponderComunicacaoPublicaPage = lazy(() =>
  import('../pages/Publico/ResponderComunicacao').then((m) => ({ default: m.ResponderComunicacaoPublicaPage })),
)

type ProtectedRouteProps = {
  children: ReactElement
  isAuthenticated: boolean
  permission: string | string[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  isAuthenticated,
  permission,
}) => {
  const location = useLocation()
  const { handleHasPermission, isLoading } = useAuthContext()

  if (isLoading) return <LoadingPage />

  const userHasRequiredHole = Array.isArray(permission)
    ? permission.some((p) => handleHasPermission(p))
    : handleHasPermission(permission)

  if (isAuthenticated && !userHasRequiredHole) {
    return <Navigate to='/' state={{ from: location }} />
  }

  return children
}

export const AppRoutes = () => {
  const auth = useAuth()
  useInicializarUsuario()
  const location = useLocation()
  const isPublicRoute = location.pathname.startsWith('/publico/')

  const [hasTriedSigning, setHasTriedSigning] = useState<boolean>(false)

  useEffect(() => {
    (async () => {
      if (
        !isPublicRoute &&
        !hasAuthParams() &&
        !auth.isAuthenticated &&
        !auth.activeNavigator &&
        !auth.isLoading &&
        !hasTriedSigning
      ) {
        await auth.signinRedirect()
        setHasTriedSigning(true)
      }
    })()
  }, [auth, hasTriedSigning, isPublicRoute])

  if (isPublicRoute) {
    return (
      <Suspense fallback={<LoadingPage />}>
        <Switch>
          <Route path='/publico/consulta-comunicacao' element={<ConsultaComunicacaoPublicaPage />} />
          <Route path='/publico/recuperar-senha' element={<RecuperarSenhaPublicaPage />} />
          <Route path='/publico/responder-comunicacao' element={<ResponderComunicacaoPublicaPage />} />
        </Switch>
      </Suspense>
    )
  }

  if (auth.isLoading) {
    return <LoadingPage />
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>
  }

  return (
    <AuthProvider>
      <LayoutDefault>
        <Suspense fallback={<LoadingPage />}>
          <Switch>
            <Route path='/' element={<Dashboard isMostComprehensiveProfile={true} />} />
            <Route path='/dashboard' element={<Dashboard isMostComprehensiveProfile={false} />} />
          <Route path='/processos-mprj/:id?' element={<ProcessosMprj />} />
          <Route
            path='/consultar-atendimentos'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.atendimento.consultarAtendimentos}
              >
                <ConsultarAtendimentos />
              </ProtectedRoute>
            }
          />
          <Route path='/atendimento/:id' element={<VisualizarAtendimento />} />
          <Route
            path='/registro-manual'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.registroComunicacao.cadastrarManualmente}
              >
                <RegistroManual />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-servico-area'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.servicos.cadastrar}
              >
                <CadastrarServicoArea />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-servico-area/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.servicos.visualisar}
              >
                <VisualizarServicoArea />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-servico-area'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.servicos.consultar}
              >
                <ConsultarServicoArea />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-assunto'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.assuntos.cadastrar}
              >
                <CadastrarAssunto />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-assunto'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.assuntos.consultar}
              >
                <ConsultarAssunto />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-assunto/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.assuntos.visualizar}
              >
                <VisualizarAssunto />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-pergunta'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.perguntas.consultar}
              >
                <ConsultarPergunta />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-pergunta/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.perguntas.visualizar}
              >
                <VisualizarPergunta />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-pergunta'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.perguntas.cadastrar}
              >
                <CadastrarPergunta />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-formulario'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.formularios.consultar}
              >
                <ConsultarFormulario />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-formulario/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.formularios.visualizar}
              >
                <VisualizarFormulario />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-formulario'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.formularios.cadastrar}
              >
                <CadastrarFormulario />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-dominio'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.dominios.consultar}
              >
                <ConsultarDominio />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-dominio/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.dominios.visualisar}
              >
                <VisualizarDominio />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-dominio'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.dominios.cadastrar}
              >
                <CadastrarDominio />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-metodo'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.metodos.consultar}
              >
                <ConsultarMetodo />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-metodo/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.metodos.visualizar}
              >
                <VisualizarMetodo />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-metodo'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.metodos.cadastrar}
              >
                <CadastrarMetodo />
              </ProtectedRoute>
            }
          />
          <Route
            path='/consultar-secao'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.secoes.consultar}
              >
                <ConsultarSecao />
              </ProtectedRoute>
            }
          />
          <Route
            path='/visualizar-secao/:id?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.secoes.visualizar}
              >
                <VisualizarSecao />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-secao'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={FuncionalidadesGeral.secoes.cadastrar}
              >
                <CadastrarSecao />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-atendimento/:tipo?'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={[
                  FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
                  FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
                ]}
              >
                <CadastrarAtendimento />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-atendimento/orientacao'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={[
                  FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
                  FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
                ]}
              >
                <OrientacaoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-atendimento/aditamento'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={[
                  FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
                  FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
                ]}
              >
                <AditamentoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-atendimento/consulta'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={[
                  FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
                  FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
                ]}
              >
                <ConsultaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='/cadastrar-atendimento/comunicacao'
            element={
              <ProtectedRoute
                isAuthenticated={auth.isAuthenticated}
                permission={[
                  FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
                  FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
                ]}
              >
                <ComunicacaoPage />
              </ProtectedRoute>
            }
          />
            <Route path='/caixa-entrada' element={<CaixaEntrada />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId' element={<ComunicacaoAnalisePage />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId/vinculos' element={<VinculosComunicacaoPage />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId/tratativa/encaminhar-providencia' element={<EncaminharProvidenciaPage />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId/tratativa/responder' element={<ResponderPage />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId/tratativa/anexos' element={<VisualizarAnexosTrativasPage />} />
            <Route path='/caixa-entrada/comunicacao/:comunicacaoApiId/tratativa/comentario' element={<AdicionarComentarioPage />} />
            <Route
              path='/complementacao'
              element={
                <ProtectedRoute
                  isAuthenticated={auth.isAuthenticated}
                  permission={FuncionalidadesGeral.caixaEntrada.complementarInformacao}
                >
                  <Complementacao />
                </ProtectedRoute>
              }
            />
          </Switch>
        </Suspense>
      </LayoutDefault>
    </AuthProvider>
  )
}

export default AppRoutes
